import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Table,
  FormGroup,
  Label,
  Input,
  Button,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import Pagination from 'components/Pagination';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import CreateAndEditWhiteList from '../components/ModalCreateWhiteList';
import { HeaderWhiteList } from '../components/HeaderWhiteList';
import WhiteListService from '../services/WhiteListService';
import { toast } from 'react-toastify';

const WhiteList = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [whiteListFromUpdate, setWhiteListFromUpdate] = useState({});
  const [whiteList, setWhiteList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalWhiteList, setTotalWhiteList] = useState(0);
  const [showIsEnable, setShowIsEnable] = useState(true);
  const [search, setSearch] = useState('');

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const disabledWhiteList = (id, ip_origem, host, IsEnable) => {
    WhiteListService.changeStatus(id)
      .then(() => {
        toast.success(
          `WhiteList ${ip_origem ? ip_origem : ''}${
            ip_origem && host ? ', ' : ''
          }${host ? host : ''} ${!IsEnable ? 'habilitada' : 'desabilitada'}`
        );
        getWhiteList();
      })
      .catch(() => {
        toast.error(
          `Erro ao ${!IsEnable ? 'Desabilitar' : 'Habilitar'} WhiteList ${
            ip_origem ? ip_origem : ''
          }${ip_origem && host ? ', ' : ''}${host ? host : ''}`
        );
      });
  };

  useEffect(() => {
    getWhiteList(1, search, search);
  }, [search]);

  const getWhiteList = (newPage, ip_origem, host) => {
    WhiteListService.getWithPagination({
      page: newPage || activePage,
      showIsEnable,
      ip_origem,
      host
    }).then((response) => {
      setWhiteList(response.data.data.result);
      setTotalWhiteList(response.data.data.count);
    });
  };

  const goToPage = (newPage) => {
    setActivePage(newPage);
    getWhiteList(newPage, search, search);
  };

  useEffect(() => {
    getWhiteList(1, search, search);
  }, [showIsEnable]);

  return (
    <>
      <CreateAndEditWhiteList
        isModalOpen={modalOpen}
        onModalToggle={setModalOpen}
        WhiteListFromUpdate={whiteListFromUpdate}
        getWhiteList={getWhiteList}
      />

      <HeaderWhiteList
        onClickCreateWhiteList={() => {
          setWhiteListFromUpdate(null);
          toggleModal();
        }}
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">WhiteList do Webhook</h3>
                </CardHeader>
                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca WhiteList por IP ou Domínio"
                        value={search}
                        type="text"
                        defaultValue=""
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="12" className="text-right mt-2 mt-md-1">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={!showIsEnable}
                          onChange={() => setShowIsEnable(!showIsEnable)}
                        />
                        <span>Mostrar desabilitados</span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <CardBody>
                  <Table hover={true} striped>
                    <thead>
                      <tr>
                        <th className="text-center">IP</th>
                        <th className="text-center">Domínio</th>
                        <th className="text-center">Desabilitar/Habilitar</th>
                        <th className="text-center">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {whiteList.length &&
                        whiteList.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center">{item.ip_origem}</td>
                            <td className="text-center">{item.host}</td>
                            <td className="text-center">
                              <ToggleSwitch
                                checked={item.isEnable}
                                id={item.id}
                                onChange={() =>
                                  disabledWhiteList(
                                    item.id,
                                    item.ip_origem,
                                    item.host,
                                    item.isEnable
                                  )
                                }
                              />
                            </td>
                            <td className="text-center">
                              <Button
                                color="info"
                                onClick={() => {
                                  setWhiteListFromUpdate(item);
                                  toggleModal();
                                }}
                                size="sm"
                              >
                                <li className="fas fa-user-edit"></li>
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </CardBody>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={totalWhiteList}
                  onChange={goToPage.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default WhiteList;
